@if (status$ | async; as status) {
  <div [class.in]="status === 'in'"
    [class.out]="status === 'out'"></div>
  @if (showText()) {
    {{ 'schedule.' + status | translate }}
  }
}